import React from "react";
import { NavLink } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer__box">
        <nav>
          <ul className="nav__list">
            <li className="nav__item">
              <NavLink className="nav__link link" to="/">
                Home
              </NavLink>
            </li>
            <li className="nav__item">
              <NavLink className="nav__link link" to="/foods">
                Foods
              </NavLink>
            </li>

            <li className="nav__item">
              <NavLink className="nav__link link" to="/about">
                About
              </NavLink>
            </li>
            <li className="nav__item">
              <NavLink className="nav__link link" to="/developer">
                Developer
              </NavLink>
            </li>
          </ul>
        </nav>

        <div className="developer">
          <p>Abd Alwahab</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
